<template>
  <div id="device-bg-main">
    <app-user-login-page />
  </div>
</template>

  <script>
  import AppUserLoginPage from '../components/AppUserLoginPage.vue';
    export default {
      name: 'Home',
      components: {
        AppUserLoginPage,
      },
    };
  </script>
